// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { PriceType } from '@shared/utils/History/CashItemUtils';
import { MAMode } from '../../IndicatorConstants';
import { ExpandDoubleVector } from '../../DoubleMatrix';
import { IndicatorFunctionsNew } from '../../IndicatorFunctions';
import { iBuildInIndicator } from '../../iBuildInIndicator';
export const iAO = 'iAO';
export class IAO extends iBuildInIndicator {
    constructor() {
        super(1);
        this.Signal = new ExpandDoubleVector();
    }
    get Name() {
        return iAO;
    }
    Refresh(count, newThread) {
        this.Signal.Dispose();
        this.Signal = new ExpandDoubleVector();
        super.Refresh(count, newThread);
    }
    NextBar(callBound) {
        this.Signal.Add(0.0);
        super.NextBar(callBound);
    }
    OnQuote() {
        const Parent = this.Parent;
        if (!Parent) {
            return;
        }
        this.Signal[this.Signal.Length - 1] = (this.GetPrice(PriceType.High, 0) + this.GetPrice(PriceType.Low, 0)) / 2;
        if (this.Signal.Length >= 35) {
            // Пересчитываем текущее значение индикатора
            this.SetValue(0, 0, IndicatorFunctionsNew.CallMovingFunction(MAMode.SMA, this.Signal, 5, 1) -
                IndicatorFunctionsNew.CallMovingFunction(MAMode.SMA, this.Signal, 34, 1));
        }
    }
}
